import React from "react";
import { useActivities } from "../../api/useActivities";
import ActivityComponent from "../Activity";
import Circles from "@ui/Picto/Circles";
import SidePanelLayout from "@ui/SidePanel/Layout";
import TableCard from "@ui/Table/Card";
import t from "../../i18n";
import { useIndexedProjects } from "../../api/useProjects";
import Filters, { useFilteredValuesByFilterType, useHideAutomaticActions } from "./Filters";
import More from "../Activity/More";
import Spinner from "@ui/Spinner";
import RefreshButton from "../Activity/RefreshButton";
import BlankStateV2 from "@ui/BlankStateV2";

export const Activities = React.memo(() => {
  const [filteredValues, setFilteredValues] = useFilteredValuesByFilterType({});
  const [hideSystemUserActions, setHideAutomaticActions] = useHideAutomaticActions({});
  const { activities, showUnread, unreadCount, hasMore, fetchMore, loading } = useActivities(
    filteredValues.projects,
    filteredValues.types,
    filteredValues.authors,
    [] /** eventIds not active */,
    hideSystemUserActions,
  );
  const projectsIndex = useIndexedProjects();

  return (
    <SidePanelLayout>
      <TableCard
        title={t("activity.paragraph.title")}
        headerLeft={
          <Filters
            filteredValues={filteredValues}
            setFilteredValues={setFilteredValues}
            hideSystemUserActions={hideSystemUserActions}
            setHideAutomaticActions={setHideAutomaticActions}
          />
        }
        headerRight={
          unreadCount ? <RefreshButton showUnread={showUnread} unreadCount={unreadCount} /> : null
        }
      >
        {activities.length === 0 ? (
          <BlankStateV2
            picto={<Circles />}
            title={t("activity.blank_state.title")}
            subtitle={t("activity.blank_state.global_description")}
          />
        ) : (
          <>
            <ActivityComponent
              activities={activities}
              timeZone={null}
              embeded={false}
              projectsIndex={projectsIndex}
            />
            <More
              disabled={!hasMore || loading}
              onClick={hasMore && !loading ? fetchMore : undefined}
            >
              {t("activity.body.see_more")}
              {loading ? <Spinner /> : null}
            </More>
          </>
        )}
      </TableCard>
    </SidePanelLayout>
  );
});
